<template>
  <div 
    v-if="!cookiesAccepted" 
    id="cookie-message">
    <div class="inner">
      <strong>Cookies and other technologies</strong>
      <p>
        By clicking "Accept" or continuing to use the site, you agree to the use of cookies and similar technologies to 
        enhance your experience and analyze and measure your engagement with the application. For more information or 
        withdrawing of your consent click the profile button at the bottom right of the application.
      </p>
      <button @click.prevent="acceptCookies">ACCEPT</button>
    </div>
  </div>
</template>

<script>
import { setCookie, getCookie } from '../../lib/cookies/cookies'

const cookieName = 'cookiesAccepted'

export default {
  name: 'CookieMessage',
  data() {
    return {
      cookiesAccepted: this.getCookie(cookieName) === 'true',
    }
  },
  methods: {
    setCookie,
    getCookie,
    acceptCookies() {
      this.setCookie(cookieName)
      this.cookiesAccepted = true
      this.$eventBus.$emit('cookies-accepted')
    },
  },
}
</script>

<style lang="scss">
#cookie-message {
  background: #ff00a4;
  width: 100%;
  min-height: 155px;
  position: absolute;
  bottom: 64px;
  right: 0;
  z-index: 100;
  padding: 30px 50px;
  box-sizing: border-box;
  color: #fff;

  .inner {
    float: right;
  }

  strong {
    margin: 0 0 15px;
    display: block;
  }

  p {
    width: 80%;
    float: left;
  }

  button {
    background: #fff;
    color: #ff00a4;
    width: 100px;
    height: 40px;
    border-radius: 20px;
    font-weight: bold;
    text-align: center;
    padding: 0;
    cursor: pointer;
    font-size: 130%;
    float: right;
  }
}
</style>
